import React from 'react';
import { Send, Ticket } from 'lucide-react';

const TelegramSupportCard = ({ telegramUsername, onCreateTicket }) => {
  const defaultUsername = import.meta.env.VITE_TELEGRAM_SUPPORT_USERNAME;
  const finalUsername = telegramUsername || defaultUsername;
  
  const handleTelegramClick = () => {
    const telegramUrl = finalUsername 
      ? `https://t.me/${finalUsername}`
      : 'https://t.me/'; // Replace with your actual Telegram username
    window.open(telegramUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-lg p-6 mb-6 border border-blue-100">
      <h3 className="text-lg font-semibold text-gray-800 mb-4">
        Choose Your Support Channel
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Telegram Support Card */}
        <button
          onClick={handleTelegramClick}
          className="flex flex-col items-center justify-center p-6 bg-white rounded-lg border-2 border-[#0088cc] hover:border-[#0077b5] hover:shadow-lg transition-all duration-300 group"
        >
          <div className="bg-[#0088cc] text-white rounded-full p-4 mb-4 group-hover:scale-110 transition-transform duration-300">
            <Send className="w-8 h-8" />
          </div>
          <h4 className="text-lg font-semibold text-gray-800 mb-2">
            Chat via Telegram
          </h4>
          <p className="text-sm text-gray-600 text-center mb-3">
            Get instant responses from our support team
          </p>
          <div className="flex items-center text-green-600 text-sm font-medium">
            <span className="w-2 h-2 bg-green-500 rounded-full mr-2 animate-pulse"></span>
            Usually replies instantly
          </div>
        </button>

        {/* Ticket System Card */}
        <button
          onClick={onCreateTicket}
          className="flex flex-col items-center justify-center p-6 bg-white rounded-lg border-2 border-blue-300 hover:border-blue-500 hover:shadow-lg transition-all duration-300 group"
        >
          <div className="bg-blue-600 text-white rounded-full p-4 mb-4 group-hover:scale-110 transition-transform duration-300">
            <Ticket className="w-8 h-8" />
          </div>
          <h4 className="text-lg font-semibold text-gray-800 mb-2">
            Create a Ticket
          </h4>
          <p className="text-sm text-gray-600 text-center mb-3">
            For detailed issues with tracking and documentation
          </p>
          <div className="flex items-center text-blue-600 text-sm font-medium">
            <span className="w-2 h-2 bg-blue-500 rounded-full mr-2"></span>
            24-48 hour response time
          </div>
        </button>
      </div>

      <div className="mt-4 p-4 bg-blue-50 rounded-lg border border-blue-100">
        <p className="text-xs text-gray-600 text-center">
          💡 <strong>Tip:</strong> For urgent issues, use Telegram for faster response. 
          For complex issues requiring documentation, create a ticket.
        </p>
      </div>
    </div>
  );
};

export default TelegramSupportCard;
